import { useSettingsStore } from "@/stores/settings";

/**
 * Sort list of drive items by property and direction
 * @param { Array } driveItems Drive items to sort
 * @param { string } orderByProperty Property to sort by
 * @param { string } orderByDirection Direction to sort (desc or asc)
 * @returns { Array } New list with sorted drive items
 */
export function sortDriveItems(driveItems, orderByProperty, orderByDirection) {
  const settingsStore = useSettingsStore();
  const folders = driveItems.filter(t => Object.prototype.hasOwnProperty.call(t, "folder"));
  const documents = driveItems.filter(t => !Object.prototype.hasOwnProperty.call(t, "folder"));

  switch (orderByProperty) {
    case "kind":
      folders.sort((a, b) => a.extension.name.localeCompare(b.extension.name, settingsStore.language));
      documents.sort((a, b) => a.extension.name.localeCompare(b.extension.name, settingsStore.language));
      break;

    case "size":
      folders.sort((a, b) => (a.size > b.size ? 1 : -1));
      documents.sort((a, b) => (a.size > b.size ? 1 : -1));
      break;

    case "modifieddate":
      folders.sort((a, b) => (a.lastModifiedDateTime > b.lastModifiedDateTime ? 1 : -1));
      documents.sort((a, b) => (a.lastModifiedDateTime > b.lastModifiedDateTime ? 1 : -1));
      break;

    case "createddate":
      folders.sort((a, b) => (a.createdDateTime > b.createdDateTime ? 1 : -1));
      documents.sort((a, b) => (a.createdDateTime > b.createdDateTime ? 1 : -1));
      break;

    case "modifiedBy":
      folders.sort((a, b) => a.lastmodifiedBy.localeCompare(b.lastmodifiedBy, settingsStore.language));
      documents.sort((a, b) => a.lastmodifiedBy.localeCompare(b.lastmodifiedBy, settingsStore.language));
      break;

    default:
      folders.sort((a, b) => a.name.localeCompare(b.name, settingsStore.language));
      documents.sort((a, b) => a.name.localeCompare(b.name, settingsStore.language));
      break;
  }

  if (orderByDirection === "desc") {
    return [...documents.reverse(), ...folders.reverse()];
  }
  return [...folders, ...documents];
}
